import { Injectable, signal } from '@angular/core';
import { UserInfoResponse } from '../domain/profile.response';

@Injectable({ providedIn: 'root' })
export class UserProfileStore {
  private readonly _profile = signal<UserInfoResponse | null>(null);
  readonly profile = this._profile.asReadonly();
  set(p: UserInfoResponse | null) {
    this._profile.set(p);
  }
  clear() {
    this._profile.set(null);
  }
}
